import React from "react";

import { DynamicSubscriptionButton } from "scmp-app/lib/sdk/dynamics";

import {
  ButtonContainer,
  Container,
  SubscribeDetails,
  Title,
  TitleAndDetailsContainer,
} from "./styles";

export type Props = {
  className?: string;
};

export const FooterSubscriptionWidget: React.FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <TitleAndDetailsContainer>
      <Title>Subscribe to the SCMP</Title>
      <SubscribeDetails>
        Critical insights and analysis on China that matter to the world
      </SubscribeDetails>
    </TitleAndDetailsContainer>
    <ButtonContainer>
      <DynamicSubscriptionButton location="footer" variant="light-blue" />
    </ButtonContainer>
  </Container>
);

FooterSubscriptionWidget.displayName = "FooterSubscriptionWidget";
